import 'normalize.css';
import {RouterProvider} from 'react-router';
import {QueryClientProvider} from '@tanstack/react-query';
import {router} from './router';
import {queryClient} from '../api/queryClient';

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}

export default App;
